import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import 'css/style.css';

import App from 'js/scenes/App';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
  